<script setup lang="ts">
import { computed } from "vue";

const currentYear = computed(() => new Date().getFullYear());
</script>

<template>
  <div class="container footer">
    <p class="text-muted credit">© {{ currentYear }} | Aligera</p>
  </div>
</template>
